import { makeClassName } from '@siteless/util';
import useCopy from '../util/useCopy';

export let ScoringModeInput = ({
  value,
  onChange,
  stacked,
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  stacked?: boolean;
}) => {
  let copy = useCopy();

  return (
    <div className={makeClassName(stacked && 'mb-4 last:mb-0')}>
      <div className="mb-2 text-sm font-medium uppercase text-purple-900">
        {copy.ScoringMode}
      </div>
      <div className="flex items-stretch gap-2">
        <button
          type="button"
          onClick={() => onChange(false)}
          className={makeClassName(
            'flex flex-1 flex-col justify-start rounded-xl border-4 px-3 py-3 text-left transition-colors',
            !value
              ? 'border-rose-default bg-neutral-0 text-purple-900'
              : 'border-neutral-200 bg-neutral-100 text-neutral-600',
          )}
        >
          <div className="text-md font-medium uppercase">{copy.Default}</div>
          <div className="mt-1 text-sm text-neutral-500">
            {copy.scoringModeDefaultDescription}
          </div>
        </button>
        <button
          type="button"
          onClick={() => onChange(true)}
          className={makeClassName(
            'flex flex-1 flex-col justify-start rounded-xl border-4 px-3 py-3 text-left transition-colors',
            value
              ? 'border-rose-default bg-neutral-0 text-purple-900'
              : 'border-neutral-200 bg-neutral-100 text-neutral-600',
          )}
        >
          <div className="text-md font-medium uppercase">{copy.Strict}</div>
          <div className="mt-1 text-sm text-neutral-500">
            {copy.scoringModeStrictDescription}
          </div>
        </button>
      </div>
    </div>
  );
};
